import { StandardEvents } from '@shopify/events';

/**
 * Haelt die Tabelle "Technische Daten" beim Variantenwechsel aktuell.
 *
 * Warum das noetig ist: Die Werte liegen in Metafeldern der Variante — Gewicht,
 * Abmessungen und Klemmung weichen je Variante ab. Beim Variantenwechsel morpht
 * Horizon aber nur den Varianten-Waehler selbst (siehe variant-picker.js: der
 * morphElementSelector bleibt undefined, ausser man wechselt auf ein verbundenes
 * Produkt). Ein Abschnitt weiter unten auf der Seite wuerde also weiter die
 * Werte der zuvor gewaehlten Variante zeigen — ein Fehler, den niemand bemerkt,
 * weil die Tabelle ja gefuellt aussieht.
 *
 * Horizon loest dasselbe Problem fuer Preis und Artikelnummer, indem kleine
 * Komponenten auf productSelect hoeren (product-sku.js). Der Weg hier ist
 * derselbe, nur dass die Werte nicht im Ereignis stecken: das Ereignis liefert
 * die Variante, nicht deren Metafelder. Deshalb wird der Abschnitt ueber die
 * Section Rendering API neu geholt.
 *
 * Der Listener haengt am document, weil dieser Abschnitt ausserhalb von
 * ProductInformation-... liegt und das Ereignis von dort nach oben blubbert.
 */
class BuechelSpecTable extends HTMLElement {
  #abbruch = null;

  connectedCallback() {
    document.addEventListener(StandardEvents.productSelect, this.#beiVariantenwechsel);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.productSelect, this.#beiVariantenwechsel);
    this.#abbruch?.abort();
  }

  #beiVariantenwechsel = (event) => {
    // Nur reagieren, wenn es um das Produkt dieser Seite geht — auf der
    // Produktseite stehen weiter unten Produktkacheln mit eigenen Waehlern.
    if (event.target instanceof Element && event.target.closest('product-card, quick-add-dialog')) return;

    Promise.resolve(event.promise)
      .then(({ detail } = {}) => {
        const variantenId = detail?.resource?.id;
        if (!variantenId) return;
        return this.#neuLaden(variantenId);
      })
      .catch((fehler) => {
        if (fehler?.name !== 'AbortError') console.warn('[buechel-spec-table]', fehler);
      });
  };

  async #neuLaden(variantenId) {
    const { produktUrl, abschnittId } = this.dataset;
    if (!produktUrl || !abschnittId) return;

    this.#abbruch?.abort();
    this.#abbruch = new AbortController();

    const url = new URL(produktUrl, window.location.origin);
    url.searchParams.set('section_id', abschnittId);
    url.searchParams.set('variant', variantenId);

    const antwort = await fetch(url, { signal: this.#abbruch.signal });
    if (!antwort.ok) return;

    const html = new DOMParser().parseFromString(await antwort.text(), 'text/html');
    const neu = html.querySelector('buechel-spec-table');

    // Kein Element in der Antwort heisst: bei dieser Variante ist kein Wert
    // gefuellt, der Abschnitt entfaellt. Dann hier ebenfalls leeren.
    this.innerHTML = neu ? neu.innerHTML : '';
  }
}

if (!customElements.get('buechel-spec-table')) {
  customElements.define('buechel-spec-table', BuechelSpecTable);
}
